import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js'; // include Popper e Bootstrap JS

import { LanguageProvider } from './components/LanguageContext'; // 👈 aggiunto import

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <LanguageProvider>   {/* 👈 avvolge l'app */}
      <App />
    </LanguageProvider>
  </React.StrictMode>
);
